<template>
  <div v-if="loading_page === true">
    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </v-sheet>
  </div>
  <div v-else>
    <div class="grid_line_first">
      <div class="grid_creditor_full mr-md-2 mr-lg-2 mr-xl-2">
        <v-card elevation="6" class="mr_rightCN" @click="redirect_page('/refund/refundwaitforprocess')">
          <div class="pa-3">
            <div class="py-1 font_creditor"><b>จำนวน CN รอลดหนี้ให้ลูกค้าทั้งหมด</b></div>
            <div class="grid_count mt-2">
              <div class="mx-auto">
                <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_time" :src="img_time"/>
              </div>
              <div class="pt-2 pl-5 black--text" style="font-size: 26px"><b>{{ format_number(total_reduce_cn) }}</b></div>
            </div>
          </div>
        </v-card>
        <v-card elevation="6" class="ml_rightCN" @click="redirect_page('/creditor/reportdebtor')">
          <div class="pa-3">
            <div class="grid_flex">
              <div class="py-1 font_creditor"><b>จำนวนลูกหนี้ทั้งหมด</b></div>
              <div><b style="font-size: 24px">{{ format_number(debtor_count) }}</b> <b>คน</b></div>
            </div>
            <div class="grid_count mt-2">
              <div class="mx-auto">
                <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_creditor" :src="img_creditor"/>
              </div>
              <div class="pt-2 pl-5"><b>ยอดรวม</b> <b style="font-size: 26px">{{ format_number(debtor_total_price) }}</b> <b>บาท</b></div>
            </div>
          </div>
        </v-card>
      </div>
      <div class="ml-md-2 ml-lg-2 ml-xl-2">
        <v-card elevation="6">
          <div class="pa-3">
            <div class="grid_product_list">
              <div class="mx-auto">
                <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_stand" :src="img_stand"/>
              </div>
              <div class="pt-2 pl-2" style="font-size: 26px">
                <div class="grid_flex_creditor">
                  <div><b>ยอดค้างชำระหนี้ทั้งหมด</b></div>
                  <div><b style="color: red;">{{ format_number(outstanding_balance) }}</b> <b>บาท</b></div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid_sub_product">
            <div class="mt-3 ml-5 mb-5 mr-sm-5 mr_right">
              <v-card elevation="2" @click="pu_page">
                <div class="pa-3">
                  <div class="font_creditor"><b>จำนวนเจ้าหนี้ทั้งหมด</b></div>
                  <div class="grid_count_creditor mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_creditor_all" :src="img_creditor_all"/>
                    </div>
                    <div class="pt-2 pl-5 black--text" style="font-size: 26px"><b>{{ format_number(creditor_count) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="mt-3 ml-5 mb-5 mr-5">
              <v-card elevation="2">
                <div class="pa-3">
                  <div><b>ยอดค้างชำระในรอบ 3 เดือน</b></div>
                  <div class="grid_total mt-3" v-for="(data, index) in outstanding_balance_month" :key="index">
                    <div></div>
                    <div class="text-left"><b>{{ data.month }}</b></div>
                    <div><b class="pr-5" style="color: red;">{{ format_number(data.total) }}</b> <b>บาท</b></div>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@/js/handler";
import img_time from "@/assets/wait-time.png";
import img_creditor from "@/assets/accountant_creditor.png";
import img_stand from "@/assets/money-bag.png";
import img_creditor_all from "@/assets/investor.png";
import {HTTP} from "@/axios";


export default {
  name: "Creditor_stand",
  data() {
    return {
      loading_page: false,
      img_time: img_time,
      img_creditor: img_creditor,
      img_stand: img_stand,
      img_creditor_all: img_creditor_all,
      total_reduce_cn: 0,
      creditor_count: 0,
      debtor_count: 0,
      debtor_total_price: 0,
      outstanding_balance: 0,
      outstanding_balance_month: [],
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    get_data() {
      this.outstanding_balance_month = []
      HTTP.get('dashboards/outstanding_balance')
          .then((res) => {
            if (res.data.success === true) {
              this.total_reduce_cn = res.data.cn_count
              this.creditor_count = res.data.creditor_count
              this.debtor_count = res.data.debtor_count
              this.debtor_total_price = res.data.debtor_total_price
              this.outstanding_balance = res.data.outstanding_balance
              this.outstanding_balance_month = res.data.outstanding_balance_month
            }
          })
    },
    pu_page() {
      this.$router.push('/creditor/puinvoice')
    },
    redirect_page(link_url) {
      this.$router.push(link_url)
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_line_first {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-gap: 15px 0;
}
.grid_creditor_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.grid_count {
  display: grid;
  grid-template-columns: 20% 80%;
}
.grid_count_creditor {
  display: grid;
  grid-template-columns: 20% 80%;
}
.grid_flex {
  display: flex;
  justify-content: space-between;
}
.grid_flex_creditor {
  display: flex;
  justify-content: space-between;
}
.grid_product_list {
  display: grid;
  grid-template-columns: 15% 85%;
}
.grid_sub_product {
  display: grid;
  grid-template-columns: 25% 75%;
}
.grid_total {
  display: grid;
  grid-template-columns: 25% 40% 30%;
}
.font_creditor {
  font-size: 20px !important;
}
@media only screen and (max-width: 1180px) {
  .mr_rightCN {
    margin-right: 10px !important;
  }
  .ml_rightCN {
    margin-left: 10px !important;
  }
  .font_creditor {
    font-size: 18px !important;
  }
  .grid_line_first {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_creditor_full {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .grid_total {
    display: grid;
    grid-template-columns: 10% 50% 35%;
    font-size: 24px !important
  }
  .grid_count_creditor {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .grid_sub_product {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 500px) {
  .mr_rightCN {
    margin-right: 0 !important;
  }
  .ml_rightCN {
    margin-left: 0 !important;
  }
  .grid_product_list {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .grid_creditor_full {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_flex_creditor {
    display: grid;
    grid-template-columns: 100%;
    font-size: 20px !important;
  }
  .mr_right {
    margin-right: 20px !important;
  }
  .grid_total {
    display: grid;
    grid-template-columns: 0 50% 50%;
    font-size: 16px !important
  }
}
</style>
